var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:['scrollup', _vm.isVisible ? 'visible' : '' ],attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.scrollUp()}}})}
var staticRenderFns = []

export { render, staticRenderFns }